module.exports = __webpack_public_path__ + "static/media/thumb-up-svgrepo-com (2).bbf82b44.svg";